import React from 'react'

const Item = ({code, name, location, onClickRow, inventoryType, id}) => {
  return (
    <React.Fragment>
        <span onClick={()=>onClickRow(inventoryType, id, name)}>{code}</span>
        <span onClick={()=>onClickRow(inventoryType, id, name)}>{name}</span>
        <span onClick={()=>onClickRow(inventoryType, id, name)}>{location}</span>
    </React.Fragment>
  )
}

export default Item